/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CartModel } from '@/cart/data/models';

const AUTHENTICATED_CART_KEY = 'DROPIN__CART__CART__AUTHENTICATED';

export function setPersistedCartData(data: CartModel | null) {
  if (data) {
    sessionStorage.setItem('DROPIN__CART__CART__DATA', JSON.stringify(data));
  } else {
    sessionStorage.removeItem('DROPIN__CART__CART__DATA');
  }
}

export function getPersistedCartData(): CartModel | null {
  const data = sessionStorage.getItem('DROPIN__CART__CART__DATA');

  if (data) return JSON.parse(data);

  return null;
}

export function setEstimatedShippingLocation(
  data: {
    [key: string]: string;
  } | null
) {
  if (data) {
    sessionStorage.setItem(
      'DROPIN__CART__SHIPPING__DATA',
      JSON.stringify(data)
    );
  } else {
    sessionStorage.removeItem('DROPIN__CART__SHIPPING__DATA');
  }
}

export function getEstimatedShippingLocation(): {
  [key: string]: string;
} | null {
  const data = sessionStorage.getItem('DROPIN__CART__SHIPPING__DATA');

  if (data) return JSON.parse(data);

  return null;
}

export function setAuthenticatedCart(isAuthenticated: boolean) {
  isAuthenticated
    ? localStorage.setItem(AUTHENTICATED_CART_KEY, 'true')
    : localStorage.removeItem(AUTHENTICATED_CART_KEY);
}

export function getAuthenticatedCart(): boolean {
  return localStorage.getItem(AUTHENTICATED_CART_KEY) === 'true';
}
